exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  --primary: #013188;\n  --primary-darker: #002d72;\n  --secondary: #ff720a;\n  --secondary-darker: #dd5f13;\n  --button-text: #fefefe;\n  --disabled: #c2c2c2;\n  --button-text-disabled: rgba(0,0,0,0.38);\n  --bg-auth: url(" + require("assets/imgs/login/bg.jpg") + ");\n  --logo-auth: none;\n  --logo-header: none;\n  --favicon: none;\n}\n[data-component='step-buttons'] {\n  position: absolute;\n  bottom: -100%;\n  text-align: center;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  width: 100%;\n}\n[data-component='step-buttons'] .btn {\n  display: inline-block;\n  width: 200px;\n}\n[data-component='step-buttons'] .btn.border {\n  margin-right: 20px;\n}\n@media print {\n  [data-component='step-buttons'] .btn {\n    display: none;\n  }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/step-buttons/step-buttons.component.styl
// module id = ../../../../../src/app/shared/step-buttons/step-buttons.component.styl
// module chunks = main